<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      :title="title ? '' : 'Création du contrat'">
      <template
        v-if="title"
        slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span class="">
            Création du contract
          </span>
          <span class="has-text-weight-light has-text-grey">
            <router-link
              tag="span"
              class="is-paddingless has-cursor-pointer"
              :to="{'name': 'ProgramVue', params: {id: title.id}}"
              v-if="title && title.id">
              - Programme {{ title.title }}
            </router-link>
          </span>
        </h1>
      </template>
    </page-nav-bar>
    <contract-form @updateTitle="updateTitle"></contract-form>
  </div>
</template>

<script>

export default {
  name: 'ContractCreate',
  components: {
    ContractForm: () => import('@/components/contract-matrix/ContractForm')
  },
  data () {
    return {
      title: null
    }
  },
  methods: {
    updateTitle (val) {
      this.title = val
    }
  }
}
</script>
